import { Steps } from 'antd';
import { styled } from 'styled-components';

export const WrapSetUpPage = styled.div`
  background-color: var(--bg-afterlogin-background-color);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  .ant-steps .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: #ffffff !important;
  }
  .anticon.anticon-check.ant-steps-finish-icon {
    color: #ffffff !important;
  }
  .ant-steps-item-title {
    color: black !important;
  }
`;

export const StepsWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const StepsStyled = styled(Steps)`
  .ant-steps-item-wait .ant-steps-item-icon {
    background-color: #272626 !important;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background-color: #0c5992;
    border-color: #0c5992;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #0c5992;
    border-color: #0c5992;
  }
  margin-top: 20px;
  width: 100%;
`;
export const StepsContent = styled.div`
  padding: 20px 50px;
  width: calc(100% - 100px);
`;
